import React, {Fragment}from 'react';
import {assertNowIsBetween} from 'Utils/commonUtils';



const HolidayMainContent = (props) => {
    return (
        <Fragment>
          <HolyWeekMessage />
        </Fragment>
    );
};

const AlerNotice = () => {
  return (
    <Fragment>
      <div style={{ textAlign: 'left' }}>
        <p>Brewing Up Something Better!</p>
        <p>Our site is currently undergoing a quick maintenance to serve you better.</p>
        <p>Drop as a message for orders or inquiries:<br />
          <a href="telno:0286322337">(02)8632-2337</a>&nbsp;<a href="mailto:632beer@smb.sanmiguel.com.ph">632beer@smb.sanmiguel.com.ph</a><br />
          <a href="https://smbdelivers.com/contact-us" target="_blank">Contact Us section</a><br />
          <a href="https://www.facebook.com/SMBDelivers?mibextid=wwXIfr" target="_blank">SMB Delivers Facebook page</a></p>
        <p>Thanks for your patience, and cheers to good SMB!</p>
      </div>
    </Fragment>
  )
}

export const ChristmasBreakMessage = () => {
  return (
    <Fragment>
      <p>Holiday Operations. </p>
      <p>Please be advised that SMB Delivers will not be available on December 25, 2024 and January 1, 2025.</p>
      <p>Plan ahead and book your orders through <a href='https://www.smbdelivers.com/'>www.SMBDelivers.com</a> or (02)8632-2337.</p>
    </Fragment>
  )
}

export const NonHolyWeekMessage = () => {
  return (
    <Fragment>
        <p>Rest assured that we put everyone's health and safety first, and fully comply with the Government's enhanced community quarantine requirements.</p>
        <p>
          Order through <a href='https://www.smbdelivers.com/'>www.SMBDelivers.com</a> or 028632BEER(2337)
        </p>
    </Fragment>
  );
};

export const ElectionMessage = () => {
  return (
    <Fragment>
      <p>Please be advised that SMB Delivers will not be able from <br /><strong>May 11 and 12, 2025</strong> to observe the Liquor Ban for the Philippine Elections.</p>
      <p>You may pre-book your beer orders through <a href='https://www.smbdelivers.com/'>www.SMBDelivers.com</a></p>
    </Fragment>
  );
};

export const HolyWeekMessage = () => {
  return (
    <Fragment>
      <p>In observance of Holy Week, our delivery service will be unavailable from <br /><strong>April 02 to April 03, 2026</strong>.</p>
      <p>You may pre-book your beer orders through <a href='https://www.smbdelivers.com/'>www.SMBDelivers.com</a></p>
    </Fragment>
  );
};

export const NormalHolidayMessage = () => {
  return (
    <Fragment>
      <p>Please be advised that SMB Delivers will not be available from October 29 to 30, 2023 to observe the Liquor Ban during the Philippine Elections.</p>
      <p>You may pre-book your orders through <a href="https://www.smbdelivers.com/">www.SMBDelivers.com</a></p>
    </Fragment>
  )
}

export const NovemberHolidayMessage = () => {
  return (
    <Fragment>
      <p>In observance of All Saints' Day, our delivery service will not be available on November 1, 2024.</p>
      <p>You may pre-book your beer orders at <a href="https://www.smbdelivers.com/">www.SMBDelivers.com</a>.</p>
    </Fragment>
  )
}

export default HolidayMainContent;

